import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const ADMIN_FEATURE_GROUP: FeatureGroup = {
  guid: 'a7f2b3c1-9e4d-4a8f-b620-5c1e3d7f0100',
  name: 'admin',
  description: 'Platform-level administration features reserved for system administrators',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
